import React, { useEffect, useRef, useState } from 'react'
import './home.css'
import Navigation from '../../components/navigation'
import Footer from '../../components/footer'
import { THEMES } from '../../constatnts'
import Spacer from 'src/components/Spacer'
import PromoBlock from 'src/components/PromoBlock'
import CountUp from 'react-countup'
import { useIsInViewportOnce } from 'src/hooks'
import { useTranslation } from 'react-i18next'
import { NavButton } from 'src/components/navigation/nav'
import { Dialog, IconButton } from '@mui/material'
import { Form } from 'src/components/form'

const Intersector = ({ children }) => {
  const someRef = useRef(null)
  const isInViewport = useIsInViewportOnce(someRef)

  return <div ref={someRef}>{isInViewport && children}</div>
}

export const HomePage = ({ isAllowed }) => {
  const { t } = useTranslation()
  const [requestDemoModalOpen, setRequestDemoModalOpen] = useState(false)

  useEffect(() => {
    requestDemoModalOpen ? (document.body.style.position = 'fixed') : (document.body.style.position = 'relative')
    requestDemoModalOpen ? (document.body.style.width = '100vw') : (document.body.style.width = '100%')
  }, [requestDemoModalOpen])

  return (
    <>
      <Navigation isAllowed={isAllowed} theme={THEMES.dark} />
      <section className='dark heading-section'>
        <div className='hide mob-show home-mob-main-img'></div>
        <div className='container'>
          <div className='row row-center mob-column-reverse mob-column-center'>
            <div className='column column-start one-of-2 mob-fullwidth mob-column-center' style={{ maxWidth: 400 }}>
              <h1 className='mob-text-center'>{t('home.title')}</h1>

              <p
                className='mob-text-center heading-description mw371 mom-mw305'
                style={{ marginTop: '33px', color: '#4A4A4A', maxWidth: 400 }}
              >
                {t('home.subtitle')}
              </p>

              <NavButton
                fullwidth={true}
                onClick={() => {
                  window.open('https://security.penprotect.ai/activate')
                }}
                variant='dark'
                size='md'
              >
                Activate
              </NavButton>
            </div>
          </div>
        </div>
      </section>
      <section className='header-to-dark darker padding140-150 box-shadow'>
        <div className='container'>
          <div className='column column-center'>
            <h2 className='text-center mb100 mob-mb-73 mw900 mob-mw341 mob-sato-26'>{t('home.setction2title')}</h2>
          </div>
          <div className='row space-between mob-column margin--40 mob-margin-0'>
            <div className='column column-center one-of-4 mob-fullwidth mob-mb-40'>
              <div className='gradient-text text-center big-num mb40 mob-mb-20'>
                {' '}
                <Intersector>
                  <CountUp end={93} />%
                </Intersector>
              </div>
              <p className='text-center font16 mob-font14 mob-font500 mw279'>{t('home.setction2text1')}</p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-40'>
              <div className='gradient-text text-center big-num mb40 mob-mb-20'>
                <Intersector>
                  <CountUp end={82} />%
                </Intersector>
              </div>
              <p className='text-center font16 mob-font14 mob-font500 mw339 mob-mw299'>{t('home.setction2text2')}</p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-20'>
              <div className='gradient-text text-center big-num mb40 mob-mb-20'>
                <Intersector>
                  <CountUp duration={3} end={30} />%
                </Intersector>
              </div>
              <p className='text-center font16 mob-font14 mob-font500 mw279 mob-mw245'>{t('home.setction2text3')}</p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-20'>
              <div className='gradient-text text-center big-num mb40 mob-mb-20'>
                <Intersector>
                  $<CountUp duration={3} end={4} />
                  .45M
                </Intersector>
              </div>
              <p className='text-center font16 mob-font14 mob-font500 mw279 mob-mw245'>{t('home.setction2text4')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className='dark pt120 pb50'>
        <div className='container1080'>
          <div className='column'>
            <div className='br30 mob-br20 mb40 mob-mb-20 padding-65-70 mob-padding-45-41 content-box'>
              <div className='row row-center space-between mob-column-reverse'>
                <div className='one-of-2 mob-fullwidth img-container-ajg-1'>
                  <img width='100%' src='/images/graphic-1-d.png' alt='' />
                  {/* <img className='mob-img hide mob-show' src="/images/graphic-1-d-mobile.png" alt="" /> */}
                </div>

                <div className='mob-mb-20 one-of-2 mob-fullwidth'>
                  <h3
                    style={{ maxWidth: '300px', fontFamily: 'PT Sans', color: '#5E2751' }}
                    className='mb36 mob-font26 mb30'
                  >
                    Secure Humans
                  </h3>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'PT Sans' }}>
                    The biggest contributor to a cyber incident is human vulnerability. Each month we will host a series
                    of cybersecurity training webinars designed for your employees at all levels of understanding.
                    Throughout the year, your staff can be trained by our specialist cybersecurity team in the role they
                    can play in defending your organisation. Topics will include boundary control, email security and
                    phishing, working from home, data protection and more.
                  </p>
                </div>
              </div>
            </div>
            <div className='br30 mob-br20 mb40 mob-mb-20 padding-65-70 mob-padding-45-41 content-box'>
              <div className='row row-center space-between mob-column'>
                <div className='mob-mb-20 one-of-2 mob-fullwidth'>
                  <h3
                    style={{ maxWidth: '300px', fontFamily: 'PT Sans', color: '#5E2751' }}
                    className='mb36 mob-font26 mb30'
                  >
                    Continuous Vulnerability Scanning
                  </h3>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'PT Sans' }}>
                    Our Pen Protect team will monitor your external boundaries and provide you updates as to the known
                    vulnerabilities with your technology portfolio. This report will outline where your low, medium and
                    high risk technology vulnerabilities reside.
                  </p>
                </div>

                <div className='one-of-2 mob-fullwidth img-container-ajg-2'>
                  <img width='100%' src='/images/cvs.jpg' alt='' />
                  {/* <img className='mob-img hide mob-show' src="/images/cvs-mobile.jpg" alt="" /> */}
                </div>
              </div>
            </div>
            <div className='br30 mob-br20 mb40 mob-mb-20 padding-65-70 mob-padding-45-41 content-box'>
              <div className='row row-center space-between mob-column-reverse'>
                <div className='one-of-2 mob-fullwidth img-container-ajg-3'>
                  <img width='100%' src='/images/tiw.png' alt='' />
                  {/* <img className='mob-img hide mob-show' src="/images/tiw-mobile.png" alt="" /> */}
                </div>

                <div className='mob-mb-20 one-of-2 mob-fullwidth'>
                  <h3
                    style={{ maxWidth: '300px', fontFamily: 'PT Sans', color: '#5E2751' }}
                    className='mb36 mob-font26 mb30'
                  >
                    Threat intelligence webinars
                  </h3>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'PT Sans' }}>
                    Forewarned is forearmed. As a global insurance provider we deal with a huge amount of claims, and
                    from this, we gain extensive intelligence on the latest threats and methods of attack. We provide
                    real-time updates on where your organisation needs to be focusing its cyber defence efforts.
                  </p>
                </div>
              </div>
            </div>
            <div className='br30 mob-br20 mb40 mob-mb-20 padding-65-70 mob-padding-45-41 content-box'>
              <div className='row row-center space-between mob-column'>
                <div className='mob-mb-20 one-of-2 mob-fullwidth'>
                  <h3
                    style={{ maxWidth: '300px', fontFamily: 'PT Sans', color: '#5E2751' }}
                    className='mb36 mob-font26 mb30'
                  >
                    Virtual CISO
                  </h3>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'PT Sans' }}>
                    Gain access to a Virtual Chief Information Security Officer (CISO) who will provide guidance and
                    support. Leverage their expertise to assess your current cybersecurity posture, develop strategies,
                    and address any concerns or questions you may have.
                  </p>
                </div>

                <div className='one-of-2 mob-fullwidth img-container-ajg-4'>
                  <img width='100%' src='/images/vcisco.png' alt='' />
                  {/* <img className='mob-img hide mob-show' src="/images/vcisco-mobile.png" alt="" /> */}
                </div>
              </div>
            </div>
            <div className='br30 mob-br20 mb40 mob-mb-20 padding-65-70 mob-padding-45-41 content-box'>
              <div className='row row-center space-between mob-column-reverse'>
                <div className='one-of-2 mob-fullwidth img-container-ajg-5'>
                  <img className='mob-hide' width='100%' src='/images/ajg-newsletter.jpg' alt='' />
                  <img className='mob-img hide mob-show' src='/images/ajg-newsletter-mobile.jpg' alt='' />
                </div>

                <div className='mob-mb-20 one-of-2 mob-fullwidth'>
                  <h3
                    style={{ maxWidth: '400px', fontFamily: 'PT Sans', color: '#5E2751' }}
                    className='mb36 mob-font26 mb30'
                  >
                    Pen Protect Cyber Risk Matters Newsletter
                  </h3>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'PT Sans' }}>
                    We will send you regular email updates on the latest cyber thinking so that you can stay informed.
                    We are in the age of information, and these key insights can support you to make key changes and
                    adaptions to your security efforts.
                  </p>
                </div>
              </div>
            </div>

            <div className='br30 mob-br20 mb40 mob-mb-20 padding-65-70 mob-padding-45-41 content-box'>
              <div className='row row-center space-between mob-column'>
                <div className='mob-mb-20 one-of-2 mob-fullwidth'>
                  <h3
                    style={{ maxWidth: '500px', fontFamily: 'PT Sans', color: '#5E2751' }}
                    className='mb36 mob-font26 mb30'
                  >
                    Community Intelligence
                  </h3>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'PT Sans' }}>
                    You will be part of a community of security professionals where your contribution counts. You will
                    be invited to monthly discussions about key security concerns and live threats your organisation
                    needs to be aware of. We will be bringing forward thought leadership and solutions for network
                    configuration, technology optimisation, risk management and risk transfer. As a collective, we are
                    stronger together in the offensive efforts against cyber criminals.
                  </p>
                </div>
                <div className='spacer'></div>
                <div className='one-of-2 mob-fullwidth img-container-ajg-7'>
                  <img className='mob-hide' width='100%' src='/images/community-ingelligence.jpg' alt='' />
                  <img className='mob-img hide mob-show' src='/images/community-ingelligence-mobile.jpg' alt='' />
                </div>
              </div>
            </div>
            <div className='br30 mob-br20 mb40 mob-mb-20 padding-65-70 mob-padding-45-41 content-box'>
              <div className='row row-center space-between mob-column-reverse'>
                <div className='one-of-2 mob-fullwidth img-container-ajg-8'>
                  <img width='100%' src='/images/other-services.png' alt='' />
                  {/* <img className='mob-img hide mob-show' src="/images/other-services-mobile.png" alt="" /> */}
                </div>
                <div className='mob-mb-20 one-of-2 mob-fullwidth'>
                  <h3
                    style={{ maxWidth: '500px', fontFamily: 'PT Sans', color: '#5E2751' }}
                    className='mb36 mob-font26 mb30'
                  >
                    Other Security Services
                  </h3>
                  <p
                    className='font18-400  mob-mb-20'
                    style={{ color: '#4A4A4A', fontFamily: 'PT Sans', maxWidth: 340 }}
                  >
                    Take advantage of the wider security services Pen Protect provides, and receive preferential pricing
                    as a Pen Protect member. Services, such as penetration testing, phishing simulations, ISO27001,
                    incident response planning, maturity assessments and more, are all available to you when you become
                    part of our community.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='dark pb150 mob-pb-20'>
        <PromoBlock onModalOpen={() => setRequestDemoModalOpen(true)} buttonText={'Request a demo'}>
          <p className='sato34 mb36 font500 mob-mw263 mob-font-24'>
            Start your journey with Pen Protect.
            <br /> Connect with a{' '}
            <a
              className='sato34 mb36 font500 mob-mw263 mob-font-24'
              style={{ color: 'rgb(174, 37, 115)' }}
              href='mailto:penprotect@penunderwriting.com'
            >
              specialist
            </a>
            .
          </p>
        </PromoBlock>
      </section>

      <Footer isAllowed={isAllowed} theme={THEMES.dark} />

      <Dialog
        sx={{ '& .MuiPaper-root': { width: 500 } }}
        onClose={() => setRequestDemoModalOpen(false)}
        open={requestDemoModalOpen}
      >
        <div className='row' style={{ padding: '10px 10px 0px 0px' }}>
          <Spacer />
          <IconButton onClick={() => setRequestDemoModalOpen(false)}>
            <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M6.92358 6.75391L19.4236 19.2539' stroke='#0B1720' strokeWidth='1.75' strokeLinecap='round' />
              <path d='M6.92358 19.2461L19.4236 6.7461' stroke='#0B1720' strokeWidth='1.75' strokeLinecap='round' />
            </svg>
          </IconButton>
        </div>
        <Form onClose={() => setRequestDemoModalOpen(false)} />
      </Dialog>
    </>
  )
}
